// What the home page's Shop and Recipes sections show until an admin saves their own version.
// productIds is empty: until then the server shows the first few products in the shop. The
// recipe cards start with the photos and pages the old home page linked to.
const HOME_DEFAULTS = {
  shopHeading: "Shop",
  productIds: [],
  recipesHeading: "Recipes",
  recipeCards: [
    { title: "Face", text: "Creams · Serums", image: "/images/for-face-II.webp", link: "/FaceCream" },
    { title: "Body", text: "Butters · Polishes", image: "/images/for-body-II.webp", link: "/BodyWash" },
    { title: "Soaps", text: "", image: "/images/for-scrub-II.webp", link: "/Soaps" },
  ],
};

// Same limits as the server (server/src/sitePages/sitePages.js).
export const HOME_LIMITS = {
  heading: 80,
  products: 8,
  cards: 6,
  cardTitle: 60,
  cardText: 120,
};

// The recipe pages a recipe card can open (the server accepts only these).
export const RECIPE_LINKS = [
  { path: "/Recipes", label: "All recipes" },
  { path: "/FaceCream", label: "For Face" },
  { path: "/BodyWash", label: "For Body" },
  { path: "/Soaps", label: "Soaps" },
];

// Recipe card rows in the editor need a stable key while they're added, moved and removed.
// It isn't saved.
let rowKeyCount = 0;
export const newRowKey = () => ++rowKeyCount;

export default HOME_DEFAULTS;
